<template>
  <div class="cywt_box">
    <div class="cywt_tiele">
      <div class="" style="font-weight: 700">常见问题</div>
      <div class="cywt_tiele_guanbi" @click="$parent.xuanfumianbanShow = true">
        <img src="../assets/img/sftk/guanbi01.png" alt="">
      </div>
    </div>

    <!-- 搜索 -->
    <div class="cywt_shousuo">
      <input
        v-model="searchForm.param.question"
        type="text"
        placeholder="请输入搜索内容"
      >

      <div class="cywt_shousuo_btn" @click="hcywtAll">
        <img src="../assets/img/sftk/sousuo.png" alt="">
      </div>
    </div>

    <!-- 内容 -->
    <div class="cywt_neirong">
      <ul>
        <li v-for="(item, k) in cywtList" :key="k">
          <div class="Li_top">
            <div class="Li_top_img">
              <img src="../assets/img/sftk/wenti.png" alt="">
            </div>
            <div class="Li_top_test" :title="item.question">
              {{ item.question }}
            </div>
          </div>
          <div class="Li_bottom">
            <div class="Li_bottom_img">
              <img src="../assets/img/sftk/huida.png" alt="">
            </div>
            <div class="Li_bottom_test" v-html="item.answer" />
          </div>
        </li>
      </ul>
    </div>

    <div class="cywt_fenye">
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :page-sizes="[10, 20, 30, 40]"
        :total="total"
        :page-size="searchForm.size"
        :current-page="searchForm.page"
        style="margin: 20px 0"
        @size-change="handleHomeSize"
        @current-change="handleHomeChange"
      />
    </div>
  </div>
</template>

<script>
import { APIcywtALL } from '@/assets/js/cywt.js'
export default {
  name: 'Cywt',
  data() {
    return {
      total: 0,
      searchForm: {
        page: 1,
        size: 10,
        param: {
          question: ''
        }
      },
      cywtList: []
    }
  },
  mounted() {
    this.hcywtAll()
  },
  methods: {
    hcywtAll() {
      APIcywtALL(this.searchForm).then((res) => {
        this.cywtList = res.data.data.rows
        this.total = res.data.data.total

      })
    },

    handleHomeSize(val) {
      this.searchForm.size = val
      this.hcywtAll()
    },
    // 首页size改变的时候
    handleHomeChange(val) {
      this.searchForm.page = val
      this.hcywtAll()
    }
  }
}
</script>

<style scoped lang="less">
.cywt_box {
  width: 90%;
  height: 100%;
  margin: 0 auto;

  .cywt_tiele {
    width: 100%;
    height: 50px;
    padding: 20px 0;
    margin-bottom: 40px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;

    .cywt_tiele_guanbi {
      //   img {
      //     width: 20px;
      //   }
      //   width: 30px;
      //   height: 30px;
      //   border: 1px solid #333;
      //   border-radius: 50%;
      //   text-align: center;
      //   line-height: 30px;
    }
  }

  .cywt_shousuo {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    input {
      width: 95%;
      border: 0;
      background-color: #f8faff;
      padding-left: 20px;

      &:focus {
        outline: none;
      }
    }
    .cywt_shousuo_btn {
      width: 5%;
      background-color: #1277e8;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      color: #fff;
    }
  }

  .cywt_neirong {
    width: 100%;
    margin-bottom: 20px;

    ul {
      list-style: none;
      padding: 0;
      width: 100%;
      li {
        width: 100%;
        margin-bottom: 20px;

        .Li_top {
          width: 100%;
          height: 35px;
          display: flex;
          justify-content: space-between;
          line-height: 35px;

          .Li_top_img {
            width: 5%;
          }
          .Li_top_test {
            width: 95%;
            color: #1277e8;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .Li_bottom {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          .Li_bottom_img {
            width: 5%;
            line-height: 35px;
          }
          .Li_bottom_test {
            width: 95%;
            padding: 0 1%;
            background-color: #f7f7f7;
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
    }
  }

  .cywt_fenye {
    width: 100%;
    padding-bottom: 20px;
  }
}
</style>
